[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 8,
                "y": 11,
                "key": "i1otH"
            },
            {
                "x": 8,
                "y": 8,
                "key": "NBPXU"
            },
            {
                "x": 9,
                "y": 8,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 9,
                "y": 7,
                "key": "6dIxq"
            },
            {
                "x": 12,
                "y": 7,
                "key": "gTp5H"
            },
            {
                "x": 12,
                "y": 11,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 6,
                "y": 12,
                "key": "OS8QJ"
            },
            {
                "x": 11,
                "y": 12,
                "key": "Qqyb0"
            },
            {
                "x": 11,
                "y": 15,
                "key": "5Q5C4"
            },
            {
                "x": 6,
                "y": 15,
                "key": "_bpdf"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 12,
                "key": "wMwHi"
            },
            {
                "x": 15,
                "y": 12,
                "key": "cp4C_"
            },
            {
                "x": 15,
                "y": 15,
                "key": "z8YxW"
            },
            {
                "x": 12,
                "y": 15,
                "key": "mzhLh"
            }
        ]
    },
    {
        "key": "4",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 13,
                "y": 6,
                "key": "djPml"
            },
            {
                "x": 16,
                "y": 6,
                "key": "5G6y6"
            },
            {
                "x": 16,
                "y": 7,
                "key": "MN76N"
            },
            {
                "x": 17,
                "y": 7,
                "key": "Vp6PA"
            },
            {
                "x": 17,
                "y": 8,
                "key": "ySHHM"
            },
            {
                "x": 18,
                "y": 8,
                "key": "UpOJ9"
            },
            {
                "x": 18,
                "y": 11,
                "key": "nHP0S"
            },
            {
                "x": 13,
                "y": 11,
                "key": "kvAK4"
            }
        ]
    },
    {
        "key": "5",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 16,
                "y": 12,
                "key": "oRhF2"
            },
            {
                "x": 19,
                "y": 12,
                "key": "kjvTL"
            },
            {
                "x": 19,
                "y": 13,
                "key": "VJxRD"
            },
            {
                "x": 20,
                "y": 13,
                "key": "1mRLi"
            },
            {
                "x": 20,
                "y": 15,
                "key": "-EiBW"
            },
            {
                "x": 16,
                "y": 15,
                "key": "SQoJy"
            }
        ]
    },
    {
        "key": "a",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 0,
                "y": 27,
                "key": "5nuYE"
            },
            {
                "x": 0,
                "y": 24,
                "key": "5o8So"
            },
            {
                "x": 1,
                "y": 24,
                "key": "ZnnhK"
            },
            {
                "x": 1,
                "y": 23,
                "key": "bNtxu"
            },
            {
                "x": 4,
                "y": 23,
                "key": "1I0KQ"
            },
            {
                "x": 4,
                "y": 24,
                "key": "KLVei"
            },
            {
                "x": 5,
                "y": 24,
                "key": "zenGA"
            },
            {
                "x": 5,
                "y": 27,
                "key": "FTmHU"
            },
            {
                "x": 4,
                "y": 27,
                "key": "iivw-"
            },
            {
                "x": 4,
                "y": 28,
                "key": "p9BDa"
            },
            {
                "x": 1,
                "y": 28,
                "key": "76XTu"
            },
            {
                "x": 1,
                "y": 27,
                "key": "aBmEQ"
            }
        ]
    },
    {
        "key": "b",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 6,
                "y": 23,
                "key": "-6Z1T"
            },
            {
                "x": 9,
                "y": 23,
                "key": "_rXc4"
            },
            {
                "x": 9,
                "y": 24,
                "key": "2GRH3"
            },
            {
                "x": 10,
                "y": 24,
                "key": "XRQrI"
            },
            {
                "x": 10,
                "y": 27,
                "key": "9RG4o"
            },
            {
                "x": 9,
                "y": 27,
                "key": "S8i3r"
            },
            {
                "x": 9,
                "y": 28,
                "key": "x8eAC"
            },
            {
                "x": 6,
                "y": 28,
                "key": "km6nR"
            }
        ]
    },
    {
        "key": "c",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 11,
                "y": 23,
                "key": "EWSR1"
            },
            {
                "x": 14,
                "y": 23,
                "key": "EEZPQ"
            },
            {
                "x": 14,
                "y": 24,
                "key": "jZTPu"
            },
            {
                "x": 15,
                "y": 24,
                "key": "jbfwz"
            },
            {
                "x": 15,
                "y": 27,
                "key": "BtNiE"
            },
            {
                "x": 11,
                "y": 27,
                "key": "kvPeo"
            }
        ]
    },
    {
        "key": "d",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 16,
                "y": 23,
                "key": "pX2uX"
            },
            {
                "x": 19,
                "y": 23,
                "key": "n2p8j"
            },
            {
                "x": 19,
                "y": 24,
                "key": "Fnpu3"
            },
            {
                "x": 20,
                "y": 24,
                "key": "2Mxoh"
            },
            {
                "x": 20,
                "y": 25,
                "key": "NDyEI"
            },
            {
                "x": 21,
                "y": 25,
                "key": "1Cva3"
            },
            {
                "x": 21,
                "y": 28,
                "key": "jLr5C"
            },
            {
                "x": 16,
                "y": 28,
                "key": "nlD3w"
            }
        ]
    },
    {
        "key": "e",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 22,
                "y": 23,
                "key": "zQaGy"
            },
            {
                "x": 25,
                "y": 23,
                "key": "sR1_q"
            },
            {
                "x": 25,
                "y": 24,
                "key": "IuE43"
            },
            {
                "x": 26,
                "y": 24,
                "key": "zOWeM"
            },
            {
                "x": 26,
                "y": 26,
                "key": "GzpPr"
            },
            {
                "x": 22,
                "y": 26,
                "key": "ROop8"
            }
        ]
    },
    {
        "key": "f",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 27,
                "y": 23,
                "key": "tzzCr"
            },
            {
                "x": 30,
                "y": 23,
                "key": "lyj3k"
            },
            {
                "x": 30,
                "y": 26,
                "key": "RJZn-"
            },
            {
                "x": 27,
                "y": 26,
                "key": "Z-Dv7"
            }
        ]
    },
    {
        "key": "g",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 31,
                "y": 23,
                "key": "TdUQb"
            },
            {
                "x": 34,
                "y": 23,
                "key": "e0WUh"
            },
            {
                "x": 34,
                "y": 27,
                "key": "B2SXd"
            },
            {
                "x": 31,
                "y": 27,
                "key": "-o8sK"
            }
        ]
    },
    {
        "key": "h",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 35,
                "y": 23,
                "key": "Z2lpi"
            },
            {
                "x": 38,
                "y": 23,
                "key": "L5rnJ"
            },
            {
                "x": 38,
                "y": 28,
                "key": "8ipiK"
            },
            {
                "x": 35,
                "y": 28,
                "key": "WDMKJ"
            }
        ]
    }
]